import { Box, Grid, List, ListItem, Typography } from "@mui/material";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import getRequest, { postRequest, putRequest, } from "../../../assets/helper/ApiHandler";
import { Link } from "react-router-dom";

var supplyObject = {
    name: "",
    isEnabled: false,
    supplyDomain: "",
    isThirdPartySupply: false,
    type: "",
    requestProcessingTime: "",
    defaultSupplyTmax: "",
    blockedCreativeAttributes: "",
    blockedCategories: "",
    blockedBannerAdTypes: "",
    supplyDescription: "",
    supplyPartner: "",
};

var formTouchedObj = {
    name: false,
    type: false,
    supplyPartner: false,
};

const values = [
    { id: 1, text: "Basic Information", path: "basic-information" },
    { id: 2, text: "Description", path: "description" },
];

export function Supply() {
    const params = useParams();
    const navigate = useNavigate();
    const toast = useRef(null);
    const [supply, setSupply] = useState(supplyObject);
    const [supplyFormError, setSupplyFormError] = useState(supplyObject);
    const [supplyPartner, setSupplyPartner] = useState([]);
    const [selectedSupplyPartners, setSelectedSupplyPartners] = useState(null);
    const [active, setActive] = useState();
    const [formTouched, setFormTouched] = useState(formTouchedObj);
    const [supplyType, setSupplyType] = useState(null);
    const [dataCenter, setDataCenter] = useState(null);
    const supplyTypeOptions = [
        { name: "RTB", value: "rtb" },
        { name: "VAST", value: "vast" },
        { name: "Prebid", value: "prebid" },
    ];
    const dataCenterOptions = [
        { name: "US EAST", value: "US_East" },
        { name: "US WEST", value: "US_West" },
        { name: "EMEA", value: "EMEA" },
        { name: "APAC", value: "APAC" },
    ];
    const formMode = params.id ? "Edit" : "Create";
    const isEditMode = params.id ? true : false;
    useEffect(() => {
        getSupplyPartners();
        if (params.id) {
            getSupply();
        }
    }, [params.id]);


    useEffect(() => {
        if (Object.values(formTouched).some((touched) => touched === true)) {
            validateFormData();
        }
    }, [supply, formTouched]);

    const getSupply = async () => {
        try {
            const supplyData = await getRequest(`/supplies/${params.id}`);
            setSupply(supplyData);
            setSupplyType(supplyData.type);
            setDataCenter(supplyData.datacenter);
            setSelectedSupplyPartners(supplyData.supplyPartner);
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };

    const getSupplyPartners = async () => {
        try {
            const supplyPartnerData = await getRequest(`/supply-partners`);
            setSupplyPartner(supplyPartnerData);
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };

    const handleCancel = () => {
        navigate("/supply");
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setSupply({
            ...supply,
            [id]: value,
        });
        setFormTouched({
            ...formTouched,
            [id]: true,
        });
    };

    const handleSupplyPartnerChange = (e) => {
        const selectedPartner = e.value;
        setSupply({
            ...supply,
            supplyPartner: selectedPartner,
        });

        setFormTouched({
            ...formTouched,
            supplyPartner: true,
        });
    };

    const handleSupplyTypeChange = (selectedSupplyType) => {
        setSupply({
            ...supply,
            type: selectedSupplyType,
        });

        setFormTouched({
            ...formTouched,
            type: true,
        });
    };

    const handleOnSubmit = () => {
        let { name: supplyName, type: supplyType } = supply;
        if (validateFormData()) {
            const payload = { ...supply, type: supplyType, datacenter: dataCenter };
            if (isEditMode) {
                updatedSupply(payload);
            } else {
                saveSupply(payload);
            }
        } else {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Invalid, Check all required field ",
            });
        }
    };
    const saveSupply = async (payload) => {
        try {
            let res = await postRequest('/supplies', payload, navigate);
                if(toast.current){
                    toast.current.show({ severity: "success", summary: 'Success', detail: "Supply  Created! " });
                }
                setTimeout(() => { navigate('/supply') }, 1000);
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    }

    const updatedSupply = async (payload) => {
        try {
            let res = await putRequest(`/supplies/${params.id}`, payload, navigate);
                if(toast.current){
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Supply  updated! ",
                    });
                }
                setTimeout(() => {
                    navigate("/supply");
                }, 1000);
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };

    const validateFormData = () => {
        let errors = {};
        let flag = false
        if (!supply.name) {
            errors.name = "Supply is required!";
        }
        if (!supply.supplyPartner) {
            errors.supplyPartner = "SupplyPartner is required!";
        }
        if (!supply.type) {
            errors.type = "Type is required!";
        }
        setSupplyFormError(errors);
        if (Object.keys(errors).length === 0) {
            flag = true;
        }
        return flag;
    };

    return (
        <div>
            <Toast ref={toast} position="bottom-right"></Toast>
            <Box className="main-content-header header-bottom-line">
                <h2>{formMode + " Supply"}</h2>
            </Box>
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <Box className="content-sticky-top">
                            <List className="list-page-link">
                                {values.map((val) => (
                                    <ListItem key={val.id} className="fs-2" onClick={() => setActive(val.id)}>
                                        <a
                                            href={"#" + val.path}
                                            style={{ textDecoration: "none" }}
                                            className={active === val.id ? "active" : ""}
                                        >
                                            {val.text}
                                        </a>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Grid>
                    <Grid
                        item
                        xs={9}
                        sx={{ gap: 1, flexGrow: 1, overflow: "hidden auto", scrollBehavior:"smooth" }}
                    >
                        <Box className="card omega-forms">
                            {isEditMode && (
                                <Grid container spacing={2} className="supply-endpoint-wrapper">
                                    <Grid item xs={12} className="supply-endpoint">
                                        <Typography level="title-sm" className="fs-1">
                                            Supply Endpoint:
                                        </Typography>
                                        <Link to={`https://amp.adelement.com/openrtb2/auction?supply_id=${params.id}`} target="_blank" rel="noopener noreferrer">
                                            {`https://amp.adelement.com/openrtb2/auction?supply_id=${params.id}`}
                                        </Link>
                                    </Grid>
                                </Grid>
                            )}

                            <Box
                                id="basic-information"
                                className={isEditMode? "basic-information-edit" : "basic-information-new"}
                                sx={{ minWidth: 0, flex: 1, padding: "1rem" }}
                            >
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography level="title-sm" className="fs-1">
                                        Basic Information
                                    </Typography>
                                </Box>

                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className="fs-2">
                                            Supply Name *
                                        </Typography>
                                        <Typography
                                            level="body-xs"
                                            className="fs-3"
                                            htmlFor="supply-partner-name"
                                        >
                                            Enter the name of the supply name
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="name"
                                            placeholder=""
                                            className={
                                                supplyFormError.name ? "mr-2 p-invalid" : "mr-2"
                                            }
                                            onChange={handleInputChange}
                                            value={supply?.name ?? ""}
                                        />
                                        {supplyFormError.name && (
                                            <Typography
                                                level="title-sm"
                                                className="error-message fs-2"
                                            >
                                                {supplyFormError.name || ''}
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className="fs-2">
                                            Supply Partner Name *
                                        </Typography>
                                        <Typography level="body-xs" className="fs-3">
                                            Select the name of supply partner name
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown
                                            value={supply?.supplyPartner ?? ''}
                                            filter
                                            className={
                                                supplyFormError.supplyPartner
                                                    ? "mr-2 p-invalid"
                                                    : "mr-2"
                                            }
                                            options={supplyPartner}
                                            onChange={handleSupplyPartnerChange}
                                            optionLabel="supplyPartnerName"
                                        />
                                        {supplyFormError.supplyPartner && (
                                            <Typography
                                                level="title-sm"
                                                className="error-message fs-2"
                                            >
                                                {supplyFormError.supplyPartner || ''}
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className="fs-2">
                                            3rd Party Supply?{" "}
                                        </Typography>
                                        <Typography level="body-xs" className="fs-3">
                                            Select if this is 3rd party supply{" "}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={8}>
                                        <Dropdown
                                            value={
                                                supply && supply.isThirdPartySupply
                                                    ? supply.isThirdPartySupply
                                                    : false
                                            }
                                            onChange={(e) =>
                                                setSupply({
                                                    ...supply,
                                                    isThirdPartySupply: e.value === true,
                                                })
                                            }
                                            options={[
                                                { name: "Yes", value: true },
                                                { name: "No", value: false },
                                            ]}
                                            optionLabel="name"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className="fs-2">
                                            Supply Type *
                                        </Typography>
                                        <Typography level="body-xs" className="fs-3">
                                            Select the type of supply{" "}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown
                                            value={supply?.type ?? ''}
                                            onChange={(e) => {
                                                handleSupplyTypeChange(e.value);
                                            }}
                                            className={
                                                supplyFormError.type ? "mr-2 p-invalid" : "mr-2"
                                            }
                                            options={supplyTypeOptions}
                                            optionLabel="name"
                                        />
                                        {supplyFormError.type && (
                                            <Typography
                                                level="title-sm"
                                                className="error-message fs-2"
                                            >
                                                {supplyFormError.type || ''}
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className="fs-2">
                                            Datacenter
                                        </Typography>
                                        <Typography level="body-xs" className="fs-3">
                                            Select a data center closest to supply{" "}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown
                                            value={dataCenter ?? ''}
                                            onChange={(e) => {
                                                setDataCenter(e.value);
                                            }}
                                            options={dataCenterOptions}
                                            optionLabel="name"
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box
                                id="description"
                                sx={{ minWidth: 0, flex: 1, padding: "1rem" }}
                                className="form-group-border-top form-group-border-bottom"
                            >
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography level="title-sm" className="fs-1">
                                        Description
                                    </Typography>
                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className="fs-2">
                                            Supply Description
                                        </Typography>
                                        <Typography
                                            level="body-xs"
                                            className="fs-3"
                                            htmlFor="supply-partner-name"
                                        >
                                            Enter a description for supply
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="supplyDescription"
                                            placeholder=""
                                            className="mr-2"
                                            value={supply?.supplyDescription ?? ""}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                            {isEditMode && (
                                <Box
                                    sx={{ minWidth: 0, flex: 1, padding: "1rem" }}
                                    className="form-group-border-bottom"
                                >
                                    <Box sx={{ minWidth: 0, flex: 1 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={4}>
                                                <Typography level="title-sm" className="fs-2">
                                                    Status
                                                </Typography>
                                                <Typography
                                                    level="body-xs"
                                                    className="fs-3"
                                                    htmlFor="demand"
                                                >
                                                    Select the status of the supply{" "}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={8}>
                                                <Dropdown
                                                    value={
                                                        supply && supply.isEnabled
                                                            ? supply.isEnabled
                                                            : false
                                                    }
                                                    onChange={(e) =>
                                                        setSupply({
                                                            ...supply,
                                                            isEnabled: e.value === true,
                                                        })
                                                    }
                                                    options={[
                                                        { name: "Active", value: true },
                                                        { name: "Stopped", value: false },
                                                    ]}
                                                    optionLabel="name"
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Box>
                            )}
                            <Box
                                sx={{
                                    minWidth: 0,
                                    display: "flex",
                                    padding: "1rem",
                                    justifyContent: "end",
                                }}
                                gap={2}
                                className="form-footer"
                            >
                                <Button
                                    type="button"
                                    className="button-style-2"
                                    label="Cancel"
                                    size="small"
                                    onClick={handleCancel}
                                ></Button>
                                <Button
                                    type="button"
                                    className="button-style-1"
                                    label="Save"
                                    size="small"
                                    onClick={handleOnSubmit}
                                ></Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
}

export default Supply;
